
export class EFormSubmissionsFilterParam {
    notSubmitted: boolean;
    submitted: boolean;
    rejected: boolean;
    accepted: boolean;
    complete: boolean;
    submittedFrom: Date;
    submittedTo: Date;  
    notSubmittedDate:Date;
    manualSubmission: string;
    
    constructor () {
        this.notSubmitted = false;        
        this.submitted = true;
        this.rejected = true;
        this.accepted = true;
        this.complete = true;
        this.manualSubmission = '0'; // Include manual submissions
    }
}
